import React, { useEffect } from 'react';
import { CustomizerConfig } from './types';
import App from './App';
import { useStore } from './store';

export const Customizer: React.FC<CustomizerConfig> = ({
  containerWidth = 500,
  containerHeight = 500,
  canvasWidth = 108,
  canvasHeight = 160,
  canvasLeft = 196,
  canvasTop = 190,
  allowedBackgroundColors,
  allowedTextColors,
  allowedFonts,
  allowCustomTextColors = true,
  allowCustomBackgroundColors = true,
  objectBackground,
  transparentBackground = true,
  initialDesign,
  onSave,
  hideExportButtons = false,
  useWooCommerceButton = true,
  productId
}) => {
  const store = useStore();

  // Apply initial design when component mounts
  useEffect(() => {
    if (initialDesign) {
      console.log('Importing initial design:', initialDesign);
      store.importDesign(initialDesign);
    }
  }, [initialDesign]);

  return (
    <App
      containerWidth={containerWidth}
      containerHeight={containerHeight}
      canvasWidth={canvasWidth}
      canvasHeight={canvasHeight}
      canvasLeft={canvasLeft}
      canvasTop={canvasTop}
      allowedBackgroundColors={allowedBackgroundColors}
      allowedTextColors={allowedTextColors}
      allowedFonts={allowedFonts}
      allowCustomTextColors={allowCustomTextColors}
      allowCustomBackgroundColors={allowCustomBackgroundColors}
      objectBackground={objectBackground}
      transparentBackground={transparentBackground}
      hideExportButtons={hideExportButtons}
      useWooCommerceButton={useWooCommerceButton}
      productId={productId}
    />
  );
};